var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1111 11.8889H13.5556M19.1111 16.3333H13.5556M19.1111 7.44444H13.5556M9.66667 3L9.66667 23M8.33333 3H17.6667C19.5335 3 20.4669 3 21.18 3.36331C21.8072 3.68289 22.3171 4.19282 22.6367 4.82003C23 5.53307 23 6.46649 23 8.33333V17.6667C23 19.5335 23 20.4669 22.6367 21.18C22.3171 21.8072 21.8072 22.3171 21.18 22.6367C20.4669 23 19.5335 23 17.6667 23H8.33333C6.46649 23 5.53307 23 4.82003 22.6367C4.19282 22.3171 3.68289 21.8072 3.36331 21.18C3 20.4669 3 19.5335 3 17.6667V8.33333C3 6.46649 3 5.53307 3.36331 4.82003C3.68289 4.19282 4.19282 3.68289 4.82003 3.36331C5.53307 3 6.46649 3 8.33333 3Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.b74db62100dc009ccc251b15de02e022.svg";
export { ForwardRef as ReactComponent };